import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        items: '<'
    },
    template
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/breadcrumbs/index.js